import { Api } from './Api'

const orderReviewsPathTo = {
  save: (data) => {
    return Api.request({
      url: '/order_reviews.json',
      method: 'post',
      data: { order_review: data }
    })
  },
}

export default orderReviewsPathTo